import { Badge, Flex } from '@chakra-ui/react';

export function FoundationSkillPicker({
  options,
  selected,
  onToggle,
  optionTestId,
}: {
  options: string[];
  selected: string[];
  onToggle: (category: string, next: boolean) => void;
  optionTestId?: string;
}) {
  return (
    <Flex gap={2} wrap="wrap">
      {options.map((category) => {
        const isOn = selected.includes(category);

        return (
          <Badge
            key={category}
            as="button"
            type="button"
            colorScheme={isOn ? 'teal' : 'gray'}
            variant={isOn ? 'solid' : 'outline'}
            fontSize="xs"
            cursor="pointer"
            data-testid={optionTestId}
            onClick={() => onToggle(category, !isOn)}
          >
            {category}
          </Badge>
        );
      })}
    </Flex>
  );
}
